import React from 'react';

const ContractsPage = () => {
  return (
    <div>
      <h1>Contracts</h1>
    </div>
  );
};

export default ContractsPage;
